import icon from 'assets/img/icons/rotate-phone.svg';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

const isMobileDevice = () => {
  if (typeof window === 'undefined') return false;

  const ua = navigator.userAgent;

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
};

const PageRotatePhone = () => {
  const { pathname } = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(isMobileDevice());
  }, []);


  if (pathname !== '/' && isMobile) {
    return (
      <div className='rotate-hint'>
        <p>Please rotate your device to continue</p>
        <img src={icon} alt="" />
      </div>
    );
  }

  return null;
};

export default PageRotatePhone;
